var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRadial(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 88.885,
    height: 88.4,
    viewBox: "0 0 88.885 88.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_53",
    x: 5.892,
    y: 0,
    width: 52.913,
    height: 61.329,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_54",
    x: 11.988,
    y: 20.266,
    width: 46.154,
    height: 41.862,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_55",
    x: 28.49,
    y: 10.094,
    width: 60.395,
    height: 52.105,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_56",
    x: 0,
    y: 31.167,
    width: 58.135,
    height: 50.496,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_57",
    x: 27.768,
    y: 31.862,
    width: 49.345,
    height: 56.538,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_58",
    x: 10.593,
    y: 31.836,
    width: 48.229,
    height: 54.936,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_59",
    x: 28.465,
    y: 31.169,
    width: 52.386,
    height: 46.44,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-7"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_60",
    x: 27.778,
    y: 10.582,
    width: 45.37,
    height: 50.919,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-8"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42",
    transform: "translate(16 16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -16, -16)",
    filter: "url(#Path_53)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53-2",
    "data-name": "Path 53",
    d: "M1235.38,1350.083c-.52-.465-1.019-.979-1.5-1.477-.226-.234-.46-.475-.695-.71-.773-.774-1.564-1.557-2.328-2.314q-.747-.74-1.492-1.481-.689-.685-1.374-1.375l-.891-.892-.221-.221c-.584-.584-1.188-1.187-1.786-1.779.152-.128.309-.261.459-.407a29.031,29.031,0,0,1,6.831-4.842,29.8,29.8,0,0,1,9.977-3.129,31.268,31.268,0,0,1,3.317-.259l.1,0c.075,0,.155,0,.22,0,0,.081,0,.187,0,.292q0,5.416,0,10.832v4.28h0v3.074c0,3.6,0,7.331,0,10.85Z",
    transform: "translate(-1203.2 -1315.19)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -16, -16)",
    filter: "url(#Path_54)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54-2",
    "data-name": "Path 54",
    d: "M1235.852,1578.831a12.764,12.764,0,0,1,1.344-1.663l10.1,9.862c-3.631-.006-12.106-.128-14.154-.157a27.9,27.9,0,0,1,.613-3.735A15.246,15.246,0,0,1,1235.852,1578.831Z",
    transform: "translate(-1205.15 -1540.9)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -16, -16)",
    filter: "url(#Path_55)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55-2",
    "data-name": "Path 55",
    d: "M882.994,1457.222a29.525,29.525,0,0,1,4.684,10.578,27.872,27.872,0,0,1,.711,5.865c0,.039,0,.094,0,.146h-.133c-9.043,0-18.665,0-28.261,0l1.8-1.8,2.673-2.671.053-.052a1.153,1.153,0,0,0,.328-.457l.173-.173a1.162,1.162,0,0,0,.443-.315l.036-.036.576-.58q.363-.366.728-.732l4.341-4.34,3.433-3.432,3.492-3.492,2.01-2.011.012-.012A31.154,31.154,0,0,1,882.994,1457.222Z",
    transform: "translate(-815.5 -1427.61)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -16, -16)",
    filter: "url(#Path_56)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_56-2",
    "data-name": "Path 56",
    d: "M1259.353,1709.488l-.484.484-.523.523-1.074,1.08q-.969.974-1.939,1.947-.837.837-1.677,1.671-.953.948-1.9,1.9-.7.706-1.4,1.416c-.506.512-1.029,1.041-1.546,1.558-.717.716-1.449,1.441-2.157,2.143q-.73.724-1.459,1.448l-.7.7c-1.193,1.186-2.427,2.412-3.632,3.629l0,0a21.319,21.319,0,0,1-2.372-2.8,27.239,27.239,0,0,1-5.257-15.45c0-.076,0-.168,0-.242.07,0,.158,0,.239,0h22.891C1257.334,1709.484,1258.348,1709.484,1259.353,1709.488Z",
    transform: "translate(-1217.22 -1662.32)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -16, -16)",
    filter: "url(#Path_57)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_57-2",
    "data-name": "Path 57",
    d: "M1009.571,1724.629l.343.343c3.361,3.362,6.837,6.838,10.267,10.245l.035.037c-.014.015-.033.034-.057.056a25.781,25.781,0,0,1-17.183,7.143l-.1,0c0-.043,0-.085,0-.115q0-5.4,0-10.8v-6.91q0-3.356,0-6.713l2,2.009Q1007.223,1722.279,1009.571,1724.629Z",
    transform: "translate(-959.1 -1670.06)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -16, -16)",
    filter: "url(#Path_58)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58-2",
    "data-name": "Path 58",
    d: "M1241.03,1740.539c-.793-.034-1.641-.08-2.466-.188a24.1,24.1,0,0,1-13.684-6.53c3.919-3.9,7.894-7.879,11.74-11.724l1.461-1.461q1.171-1.171,2.338-2.344l.686-.688v10.754h0v2.966c0,2.984,0,6.069.007,9.1a1.066,1.066,0,0,1,0,.111A.737.737,0,0,1,1241.03,1740.539Z",
    transform: "translate(-1198.29 -1669.77)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -16, -16)",
    filter: "url(#Path_59)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59-2",
    "data-name": "Path 59",
    d: "M972.844,1709.516h1.232c1.251,0,2.545,0,3.819-.008-.011.187-.015.374-.02.555-.006.26-.013.506-.035.752a21.785,21.785,0,0,1-3.221,9.682,23.853,23.853,0,0,1-2.678,3.452c-.2-.233-.426-.446-.64-.652-.1-.095-.2-.189-.294-.286l-5.558-5.555-.439-.439-5.264-5.263q-1.119-1.119-2.237-2.24h9.53v0Z",
    transform: "translate(-913.04 -1662.34)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -16, -16)",
    filter: "url(#Path_60)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60-2",
    "data-name": "Path 60",
    d: "M1056.176,1473.5l-.186.186a1.2,1.2,0,0,0-.469.345c-.021.023-.042.045-.063.067l-1.989,1.99q-1.23,1.232-2.462,2.463,0-.619,0-1.238v-17.52c0-.069,0-.121,0-.161l.134.008.473.034c.5.034,1.014.07,1.509.139a20.05,20.05,0,0,1,11.124,5.259l.011.01.115.108-.1.1-.919.917q-3.344,3.338-6.687,6.679c-.028.028-.058.055-.087.083A1.485,1.485,0,0,0,1056.176,1473.5Z",
    transform: "translate(-1007.23 -1433.05)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadial);
export default __webpack_public_path__ + "static/media/radial.59148077568ecd90643ce1edde0ea7f5.svg";
export { ForwardRef as ReactComponent };